<template>
    <span :data-balloon="tooltip" data-balloon-pos="up">
        <i @click="open" class="fa fa-copy"></i>
        <div class="remodal" :data-remodal-id="modalID">
            <p>Do you want to copy this brace <strong>{{title}}</strong>?</p>
            <button data-remodal-action="cancel" class="remodal-cancel simple">Cancel</button>
            <button data-remodal-action="confirm" class="remodal-confirm simple" @click="confirm">OK</button>
        </div>
    </span>
</template>

<script>
    import Modal from 'vue/common/_modal';

    export default {
        computed: {
            modalID() {
                return `${this.id}-copy`
            },
        },

        methods: {
            confirm() {
                this.$store.dispatch('submittalSystem/cloneBrace', {id: this.id})
                    .then(() => {
                        window.location.reload();
                    });
            },
        },
        extends: Modal,

        props: {
            id: {
                type: [String, Number]
            },
            title: {
                type: String
            },
            url: {
                type: String
            },
            tooltip: {
                default: "Copy",
                type: String
            }
        }
    }
</script>
